import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null,
      tenant: null,
      isAuthenticated: false,

      login: (token, user, tenant) =>
        set({ token, user, tenant, isAuthenticated: true }),

      logout: () =>
        set({ token: null, user: null, tenant: null, isAuthenticated: false }),

      updateUser: (updates) =>
        set((state) => ({ user: { ...state.user, ...updates } })),
    }),
    {
      name: 'peticionador-auth', // chave no sessionStorage
      storage: createJSONStorage(() => sessionStorage), // NÃO localStorage — fechar a aba encerra a sessão
      partialize: (state) => ({
        token: state.token, user: state.user, tenant: state.tenant, isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
